import { Button, Input, InputProps, Space } from "antd";
import { ColumnsType } from "antd/lib/table";
import { DatePicker, FontFa } from "../../../../../components";
import { AiOutlineCalendar } from "react-icons/ai";
import { DateHelper } from "../../../../../helper";
import { Moment } from "moment";

interface SearchTextColumnParams {
  inputSearchProps?: InputProps;
  searchBtnText?: string;
  resetBtnText?: string;
  dataIndex: string;
}
interface SearchCalendarColumnParams {
  inputSearchProps?: InputProps;
  searchBtnText?: string;
  resetBtnText?: string;
  dataIndex: string;
}

const { RangePicker } = DatePicker;

export const useSearchColumn = () => {
  const getSearchTextColumnProperties = <T extends any>(
    params: SearchTextColumnParams
  ): ColumnsType<T>[number] => {
    return {
      filterDropdown({ setSelectedKeys, selectedKeys, confirm, clearFilters }) {
        return (
          <div
            style={{
              padding: 8,
              display: "flex",
              flexDirection: "column",
              gap: 4,
            }}
          >
            <Input
              {...params.inputSearchProps}
              style={{ fontWeight: 400 }}
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
              }}
              onPressEnter={() => confirm()}
            />
            <Space style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                onClick={() => {
                  if (clearFilters) clearFilters();
                  confirm();
                }}
                type="text"
                size="small"
              >
                {params.resetBtnText ?? "Reset"}
              </Button>
              <Button onClick={() => confirm()} type="primary" size="small">
                {params.searchBtnText ?? "Ok"}
              </Button>
            </Space>
          </div>
        );
      },
      filterIcon: (filtered: boolean) => (
        <FontFa
          name="faSearch"
          size="1x"
          color={filtered ? "#007aff" : "#333"}
        />
      ),
      onFilter: (searchValue: string | number | boolean, record: any) => {
        if (!searchValue) return true;
        const recordValue: string = record[params.dataIndex];
        return recordValue
          .toLowerCase()
          .includes((searchValue as string).toLowerCase());
      },
    };
  };
  const getSearchCalendarColumnProperties = <T extends any>(
    params: SearchCalendarColumnParams
  ): ColumnsType<T>[number] => {
    return {
      filterDropdown({ setSelectedKeys, selectedKeys, confirm, clearFilters }) {
        const rangeDateValue: any = selectedKeys[0]
          ? DateHelper.rangeDateStringifyToMoment(selectedKeys[0].toString())
          : [];
        return (
          <div
            style={{
              padding: 8,
              display: "flex",
              flexDirection: "column",
              gap: 4,
            }}
          >
            <RangePicker
              value={rangeDateValue}
              onChange={(dates) =>
                setSelectedKeys(dates ? [JSON.stringify(dates)] : [])
              }
            />
            <Space style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                onClick={() => {
                  if (clearFilters) clearFilters();
                  confirm();
                }}
                type="text"
                size="small"
              >
                {params.resetBtnText ?? "Reset"}
              </Button>
              <Button onClick={() => confirm()} type="primary" size="small">
                {params.searchBtnText ?? "Ok"}
              </Button>
            </Space>
          </div>
        );
      },
      filterIcon: (filtered: boolean) => (
        <AiOutlineCalendar size={18} color={filtered ? "#007aff" : "#333"} />
      ),
      onFilter: (s: string | number | boolean, record: any) => {
        const rangeDate = DateHelper.rangeDateStringifyToMoment(s as string);
        if (!rangeDate) return true;
        const value = DateHelper.formatDateToMoment(
          record[params.dataIndex]
        ) as Moment;
        return DateHelper.isDateInRange(
          value,
          rangeDate[0].clone().startOf("days"),
          rangeDate[1].clone().endOf("days")
        );
      },
    };
  };

  return { getSearchTextColumnProperties, getSearchCalendarColumnProperties };
};
